/**
 * @generated SignedSource<<b8abfa5ee8b8dae6f037724f82fc1375>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SkillsTeacherSingleSkillByCodeQuery$variables = {
  skillCode: string;
  skip: boolean;
};
export type SkillsTeacherSingleSkillByCodeQuery$data = {
  readonly siteSpecificSkillInfoBySkillCode?: {
    readonly assessmentInfo: string | null | undefined;
    readonly code: string | null | undefined;
    readonly context: string | null | undefined;
    readonly essentialQuestion: string | null | undefined;
    readonly id: string;
    readonly name: string | null | undefined;
    readonly skillStories: ReadonlyArray<{
      readonly description: string | null | undefined;
      readonly id: string;
      readonly profession: string | null | undefined;
      readonly story: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly standards: ReadonlyArray<{
      readonly description: string | null | undefined;
      readonly id: string;
      readonly longName: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly summary: string | null | undefined;
    readonly vocabularies: ReadonlyArray<{
      readonly definition: string | null | undefined;
      readonly id: string;
      readonly term: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type SkillsTeacherSingleSkillByCodeQuery = {
  response: SkillsTeacherSingleSkillByCodeQuery$data;
  variables: SkillsTeacherSingleSkillByCodeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skillCode"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v3 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "skillCode",
            "variableName": "skillCode"
          }
        ],
        "concreteType": "SkillNode",
        "kind": "LinkedField",
        "name": "siteSpecificSkillInfoBySkillCode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "summary",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assessmentInfo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "essentialQuestion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "context",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VocabularyNode",
            "kind": "LinkedField",
            "name": "vocabularies",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "term",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "definition",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillStoryNode",
            "kind": "LinkedField",
            "name": "skillStories",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "profession",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "story",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StandardNode",
            "kind": "LinkedField",
            "name": "standards",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "longName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SkillsTeacherSingleSkillByCodeQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SkillsTeacherSingleSkillByCodeQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "579f7cd538120853f58860361f3806c6",
    "id": null,
    "metadata": {},
    "name": "SkillsTeacherSingleSkillByCodeQuery",
    "operationKind": "query",
    "text": "query SkillsTeacherSingleSkillByCodeQuery(\n  $skillCode: String!\n  $skip: Boolean!\n) {\n  siteSpecificSkillInfoBySkillCode(skillCode: $skillCode) @skip(if: $skip) {\n    name\n    id\n    code\n    summary\n    assessmentInfo\n    essentialQuestion\n    context\n    vocabularies {\n      id\n      term\n      definition\n    }\n    skillStories {\n      id\n      profession\n      story\n      description\n    }\n    standards {\n      id\n      description\n      longName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ee0442b6b46e39d7f0ae44394cc88456";

export default node;
